// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__dzlEa","item":"PaymentsMobile_item__3zs2h","label":"PaymentsMobile_label__1KAC7","amount":"PaymentsMobile_amount__2tJJY"};